import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/logo.png';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Header = ({ isAuthenticated, onLogout }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  // Toggle the body class based on menu state
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('th-body-visible');
    } else {
      document.body.classList.remove('th-body-visible');
    }
    return () => {
      document.body.classList.remove('th-body-visible');
    };
  }, [isMenuOpen]);

  const toggleMenu = () => setMenuOpen(!isMenuOpen);

  return (
    <>
      {/* Mobile Menu */}
      <div className={`th-menu-wrapper ${isMenuOpen ? 'th-body-visible' : ''}`}>
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle" onClick={toggleMenu}>
            <i className="fal fa-times" />
          </button>
          <div className="mobile-logo">
            <Link to="/">
              <img src={logo} alt="GST" />
            </Link>
          </div>
          <div className="th-mobile-menu mobile-menu">
          <ul>
                    <li>
                      <Link to="/">Home</Link>
                      </li>
                   
                     
                      <li> <Link to="/about">About Us</Link></li>
                      <li><Link to="/ourstory">Our Story</Link></li>
                      <li><Link to="/founder">Founder</Link></li>
                      <li><Link to="/Ourpartner">Our Partner</Link></li>
                      <li><Link to="/resource">Resource</Link></li>
                      <li><Link to="/annualreports">Annual Reports</Link></li>
                      <li><Link to="/financialreports">Financial Reports</Link></li>
                      <li><Link to="/gallery">Gallery</Link></li>
                      <li><Link to="/contact">Contact Us</Link></li>










                  </ul>
          </div>
        </div>
      </div>

      {/* Header */}
      <div className="top_head">
  <div className="top_left_head">
    <i className="fa fa-envelope" />
    gst_balaghat@yahoo.co.in
    <i className="fa fa-phone" />
    +91 9424906514
  </div>
  <div className="top_head_inne">
    <a
      href="#"
      title="Visit facebook page"
      target="_blank"
    >
      {" "}
      <i className="fab fa-facebook" />
    </a>
    <a
      href="#"
      title="Visit twiiter page"
      target="_blank"
    >
      {" "}
      <i className="fab fa-twitter" />
    </a>
    <a
      href="#"
      title="Visit linkedin page"
      target="_blank"
    >
      {" "}
      <i className="fab fa-linkedin" />
    </a>
    <a
      href="#"
      title="Visit Instagram page"
      target="_blank"
    >
      {" "}
      <i className="fab fa-instagram" />
    </a>
    <a
      href="#"
      title="Visit youtube page"
      target="_blank"
    >
      {" "}
      <i className="fab fa-youtube" />
    </a>
   
    <a href="/contact" title="Visit contact us page">
      Contact Us
    </a>
    <div></div>
  </div>
</div>

      <header className="th-header header-layout1 onepage-nav">
        <div className="sticky-wrapper">
          <div className="container">
            <div className="menu-area">
              {/* Logo */}
              <div className="header-logo">
                <Link to="/">
                  <img src={logo} alt="Donat Logo" />
                  <p>Prevent water, Nature and Environment test </p>
                </Link>
              </div>

              {/* Menu Area */}
              <div className="menu-area-wrap">
                <nav className="main-menu d-none d-lg-block">
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                     
                    </li>
                    <li>
                      <Link to="/about">About Us</Link>
                      <ul className="mega-menu mega-menu-content">

                      <li>
                     <a href="/ourstory">Our Story</a>
                     </li>

                     <li>
                     <a href="/founder">Founder</a>
                     </li>

                     <li>
                     <a href="/Ourpartner">Our Partner</a>
                     </li>
                     
                    
                   
                   
                     
                    
                     {/* <li>
                     <a href="/OurWork">Our Work</a>
                     </li> */}
                   
                   
                   
                   </ul>
                    </li>
                    <li><Link to="/resource">Resource</Link>
                    <ul className="mega-menu mega-menu-content">

<li>
  <a href="/annualreports">Annual Reports</a>
  </li>
  <li>
  <a href="/financialreports">Financial Reports</a>
  </li>


  {/* <li>
  <a href="/epco">EPFO</a>
  </li>

  <li>
  <a href="/fpo">FPO</a>
  </li>
  <li>
  <a href="/whatwedo">What We Do</a>
  </li> */}

 
 
</ul>
                    
                    
                    </li>

                    <li><Link to="/gallery">Gallery</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                  </ul>
                </nav>
                {/* <div className="th-social style6">
                  <a href="https://www.facebook.com/"><i className="fab fa-facebook-f" /></a>
                  <a href="https://www.twitter.com/"><i className="fab fa-twitter" /></a>
                  <a href="https://www.linkedin.com/"><i className="fab fa-linkedin-in" /></a>
                  <a href="https://www.behance.com/"><i className="fab fa-behance" /></a>
                  <a href="https://www.vimeo.com/"><i className="fab fa-vimeo-v" /></a>
                </div> */}
              </div>

              {/* Header Buttons */}
              <div className="header-button">
                <button
                  type="button"
                  className="icon-btn style2 searchBoxToggler d-lg-block d-none"
                >
                  <i className="far fa-search" />
                </button>
                <Link to="/contact" className="th-btn style3 d-xl-block d-none">
                  <i className="fas fa-heart me-2" /> Donate Now
                </Link>
                <button
                  type="button"
                  className="icon-btn th-menu-toggle d-lg-none"
                  onClick={toggleMenu}
                >
                  <i className="far fa-bars" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
